import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/halo-data-next/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutClient"] */ "/vercel/path0/packages/halo-data-next/app/layout-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/packages/halo-data-next/app/providers.tsx");
